import { ICampaign } from 'interfaces/campaign';
import { IProduct } from 'interfaces/product';
import { BehaviorSubject, Observable } from 'rxjs';
import * as rxjsOperators from 'rxjs-operators';

import apiService, { ApiService } from './api';
import { themeService } from './themeService';

export class CampaignService {
  public campaigns$ = new BehaviorSubject<ICampaign[]>(null);

  constructor(private api: ApiService) {}

  public loadCampaign(product: number, user: number): Observable<IProduct> {
    this.campaigns$.next(null);
    return this.api
      .post(`/campaign/myCampaigns`, { product, user })
      .pipe(rxjsOperators.tap(campaign => this.campaigns$.next(campaign)));
  }

  public getCampaigns() {
    return this.campaigns$.asObservable();
  }

  public setCampaign(selectedProduct: IProduct) {
    const campaigns = JSON.parse(JSON.stringify(selectedProduct.campaigns));
    this.campaigns$.next(campaigns);
  }

  public enableDisableCampaign(campaignId: number, themeId: string) {
    return this.api
      .post('/campaign', { themeId, campaignId })
      .pipe(rxjsOperators.tap((theme: any) => themeService.setDataTheme(theme.resp)));
  }
}

export const CampaignServiceFactory = () => new CampaignService(apiService);

export const campaignService = CampaignServiceFactory();
